import MainFooter from "../components/footer/main-footer";

const Footer = () =>{
    return(
        <MainFooter/>
    )
}

export default Footer;